import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, FormRow, Grid, PageTitle, useCacheQuery } from 'gossamer-front-end';
import { Institution, InstitutionParent, InstitutionParentRow } from 'cb-model';
import { getFilter, getListRowLink } from 'gossamer-unified';

export const InstitutionChildGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const query = useCacheQuery(InstitutionParent, {
    where: { and: [getFilter('parent_institution', 'eq', params.key)] },
  });
  const handleExit = () => navigate(getListRowLink(Institution.listRowLink, params.key));
  return (
    <>
      <PageTitle verb="Update" entity={InstitutionParent} />
      <FormManager
        compoundUrl="/main/~/institution-parent-grid"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'update-multi',
            entity: InstitutionParent,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={InstitutionParent}
          addRowFieldId="child_institution"
          onAddRow={(data: FormRow<InstitutionParentRow>, newValue: string) => {
            data.parent_institution = parseInt(params.key);
            data.child_institution = parseInt(newValue);
          }}
        />
      </FormManager>
    </>
  );
};
